exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swal2-styled {\n  padding:5px 15px !important;\n}\n", ""]);

// exports
